import { BACKEND_URL } from "@/lib/env";

export const ENTRA_CALLBACK_PATH = "/auth/entra/callback";
export const ENTRA_SSPR_URL = "https://passwordreset.microsoftonline.com/";
export const ENTRA_NO_ACCESS_QUERY = "entra_error";
export const ENTRA_NO_ACCESS_VALUE = "no_access";
export const ENTRA_NO_ACCESS_MESSAGE =
  "Unable to sign in. You don't have a Halo account. Ask an administrator to grant access.";

export function entraNoAccessMessage(detail) {
  const text = String(detail || "");
  if (text.toLowerCase().includes("no halo app roles") || text.toLowerCase().includes("no halo roles")) {
    return ENTRA_NO_ACCESS_MESSAGE;
  }
  return text;
}

export function isEntraCallbackPath(pathname) {
  const path = pathname ?? (typeof window !== "undefined" ? window.location.pathname : "");
  return path === ENTRA_CALLBACK_PATH || path.startsWith(`${ENTRA_CALLBACK_PATH}/`);
}

export function entraLoginUrl() {
  return `${BACKEND_URL}/api/auth/login`;
}
